module.exports = __webpack_public_path__ + "img/07.cc212c35.jpg";